import { Link } from "react-router-dom";

const stats = [
  { value: "1,800+", label: "收录作品" },
  { value: "46", label: "细分类型" },
  { value: "18", label: "精选专题" },
  { value: "每日", label: "内容更新" },
];

const features = [
  {
    icon: "ri-search-eye-line",
    title: "多维度查找",
    desc: "按影视类型、上映年份与热度排序组合筛选，几秒钟就能锁定想看的那一部。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "信息完整详实",
    desc: "导演、主演、片长、地区与剧情简介一站式呈现，看前先了解，再决定要不要追。",
  },
  {
    icon: "ri-links-line",
    title: "关联推荐",
    desc: "根据类型与专题相似度智能推荐同风格作品，顺着看下去永远不缺片。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-100 px-4 py-12 md:px-8 md:py-16">
      <div className="mx-auto w-full max-w-6xl">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_1fr] lg:gap-14">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-md bg-primary-100 px-2.5 py-1 text-xs font-medium text-primary-700">
              <i className="ri-film-line" />
              关于本站
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              一个为国产影视而建的
              <br className="hidden md:block" />
              内容索引与发现平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              国产精品久久专注于汇集最新最全的国产电影和电视剧，涵盖热门剧情和经典佳作。
              我们把散落各处的作品信息整理成清楚可查的索引：题材、年代、主创、剧情梗概，一处找齐。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              无论你是想找一部周末下饭的轻松剧，还是想重温某个年代的记忆，都可以从分类筛选或关键词搜索开始。
              本站仅提供影视内容信息展示，不提供播放、下载与付费服务，所有数据均为虚构演示用途。
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to="/category"
                className="inline-flex items-center gap-2 rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700 whitespace-nowrap cursor-pointer"
              >
                开始浏览分类
                <i className="ri-arrow-right-line" />
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 whitespace-nowrap cursor-pointer"
              >
                了解我们
              </Link>
            </div>

            <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-4 md:gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-background-200 bg-background-50 px-3 py-3"
                >
                  <p className="font-heading text-lg font-black text-primary-700 md:text-xl">
                    {stat.value}
                  </p>
                  <p className="mt-0.5 text-[11px] text-foreground-600 md:text-xs">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                  <i className={`${feature.icon} text-xl`} />
                </span>
                <div>
                  <h3 className="text-sm font-bold text-foreground-950 md:text-base">
                    {feature.title}
                  </h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600 md:text-sm">
                    {feature.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}